<template>
  <div>
    <ReportTable 
      title="Alle Aanvragen"
      :reports="reports"
      class="mt-4 pt-2 mb-5" />
  </div>
</template>

<script>
import ReportTable from 'organism/ReportTable'
import ReportModel from 'model/Report'

export default {
  components: {
    ReportTable
  },
  data() {
    return {
      reports: [
        new ReportModel({
          id: 1, 
          document_id: 'Stationstraat 7 - Sneek', 
          document_date: '6 July 2019',
          status: {
            text: 'Gecontroleerd',
            label: 'Gecontroleerd',
            bgColor: '#3D5372'
          }, 
          type: {
            text: 'Gecontroleerd',
            label: 'Gecontroleerd',
            bgColor: '#3D5372'
          },
          attribution: null, 
          document_name: 'Stationstraat 7, Sneek', 
          floor_measurement: false, 
          inspection: false, 
          joint_measurement: false, 
          norm: 'NAP', 
          note: '', 
          access_policy: false
        })
      ]
    }
  }
}
</script>

